export const inputs = [
  { type: "text", name: "name", placeholder: "Votre nom" },
  { type: "email", name: "email", placeholder: "Votre adresse E-mail" },
  // { type: "text", name: "subject", placeholder: "L'objet" },
];
